// src/pages/TourForm.js
import { useContext, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

import { MediaContext } from '../context/MediaContext';
import { getProjectById, saveProject, uploadTourZipFile } from '../services/ProjectServices';

import './Forms.css';

function TourForm() {
  const { projectId } = useParams();
  const { mediaItems } = useContext(MediaContext);
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tourName, setTourName] = useState('');
  const [tourSlug, setTourSlug] = useState('');

  const handleNameChange = (e) => {
    const newName = e.target.value;
    const newSlug = newName
      .toLowerCase()
      .replace(/[^\w\s]/gi, "")
      .replace(/\s+/g, "-"); // Generar slug
    setTourSlug(newSlug);
    setTourName(newName);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const zipFile = e.target.zipFile.files[0];
    if (!zipFile) {
      setError('Por favor selecciona un archivo .zip');
      setLoading(false);
      return;
    }
    try {
      const r = await uploadTourZipFile(projectId, tourSlug, zipFile);
      await updateProject({
        type: 'virtualTour',
        reference: tourSlug,
        url: r.url
      });
      navigate(`/projects/edit/${projectId}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProject = async (mediaItem) => {
    const newMediaItems = [...mediaItems, mediaItem];
    let projectData = await getProjectById(projectId);
    projectData.mediaItems = newMediaItems;
    await saveProject(projectData);
  }

  return (
    <div className="page-container">
      <div className="form-container">
        <h2>Nuevo Tour Virtual</h2>
        {error && (
          <div>
            <div className="error-message">Hubo un error: {error}</div>
            <br />
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="tour-name">Nombre del Tour</label>
            <input
              type="text"
              id="tour-name"
              value={tourName}
              onChange={handleNameChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="zip-file" className='form-label'>Archivo .zip</label>
            <input className='form-control' type="file" id="zip-file" name="zipFile" accept=".zip" required />
          </div>
          <div className="form-group">
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Subiendo...' : 'Subir Tour'}
            </button>
          </div>
        </form>
        <div className="form-footer">
          <Link to={`/projects/edit/${projectId}`} className="back-link">
            Regresar a Proyecto
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TourForm;
